
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CLIP_REQUEST_GET_USER_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { clipRequestGetUserResult } from 'Redux/actions';


function* searchUsersByAccount({ payload }) {
    try {
        let QUERY = `
            query searchSubUsers ($conditions: [SubUserSearchInput], $sort: [SubUserSortInput], $limit: Int, $offset: Int) {
                result: searchSubUsers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        userName
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["companyId"],
                        terms: [payload],
                        exact: true,
                    }
                ],
                sort: {
                    field: "userName",
                    order: "DESC"
                },
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data) {
            yield put(clipRequestGetUserResult(data.result.items || []))
        }
    } catch (exc) {
        yield put(clipRequestGetUserResult([]))
        ExceptionManager(
            exc,
            "Modules/devices/.components/clipRequestTab/redux/saga",
            "searchUsersByAccount",
        )
    }
}

function* watchMethods() {
    yield takeEvery(CLIP_REQUEST_GET_USER_REQUEST, searchUsersByAccount);
}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}